import { LitElement, html, css } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import gridStyle from '../styles/grid'

@customElement('vxv-main')
export class TMain extends LitElement {
    static styles = [
        css `
        :host {
            display: block;
            width: 100%;
            height: 100%;
        }
        ::slotted(*) {
            margin: 0;
            width: 100%;
            height: 100%;
        }    
        `,
        gridStyle ];

    // properties 
    @property ({ 
        type: Array, 
        attribute: 'layout-template',
        converter: {
            fromAttribute: (value: string): number[][] => {
                console.log('converting', value)
                if (!value) return [];
                try { return JSON.parse(`[${value}]`) } 
                catch (e) {
                console.error('Error parsing groups:', e);
                return [];
              }
            },
            toAttribute: (value: number[][]): string => {
              // Convert nested arrays back to string
              return value.map(group => `[${group.join(',')}]`).join(',');
            }
          } }) layout:number[][] = []

    // render function
    render() {
        console.log(this.layout)
        return html`
            <div class="container-flex">
                <div class="row g-2">
                    ${this.layout.map( (row, ri) => html`
                        ${row.map( (w, ci) => html`
                            <div class="col-${w} h-100">
                                <slot name="${ri}:${ci}"></slot>
                            </div>
                        `)}
                    `)}
                </div>
            </div>
        `;
    }
}

declare global {
  interface HTMLElementTagNameMap {
    'vxv-main': TMain;
  }
}